<a class="qaroni-link-on-surface" [routerLink]="route()">
  {{ text() }}
</a>
